import { render, staticRenderFns } from "./VersionTab.vue?vue&type=template&id=d70675d2"
import script from "./VersionTab.vue?vue&type=script&lang=js"
export * from "./VersionTab.vue?vue&type=script&lang=js"
import style0 from "./VersionTab.vue?vue&type=style&index=0&id=d70675d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports